"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRelativeDateFilterPreset = exports.isRelativeDateFilterForm = exports.isAbsoluteDateFilterPreset = exports.isAbsoluteDateFilterForm = exports.isAllTimeDateFilterOption = exports.isDateFilterGranularity = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var dateFilterGranularity = [
    "GDC.time.date",
    "GDC.time.week_us",
    "GDC.time.month",
    "GDC.time.quarter",
    "GDC.time.year",
];
/**
 * Type-guard testing whether the provided object is an instance of {@link DateFilterGranularity}.
 * @alpha
 */
exports.isDateFilterGranularity = function (obj) {
    return !isEmpty_1.default(obj) && dateFilterGranularity.some(function (granularity) { return granularity === obj; });
};
/**
 * Type-guard testing whether the provided object is an instance of {@link IAllTimeDateFilterOption}.
 * @alpha
 */
exports.isAllTimeDateFilterOption = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "allTime";
};
/**
 * Type-guard testing whether the provided object is an instance of {@link IAbsoluteDateFilterForm}.
 * @alpha
 */
exports.isAbsoluteDateFilterForm = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "absoluteForm";
};
/**
 * Type-guard testing whether the provided object is an instance of {@link IAbsoluteDateFilterPreset}.
 * @alpha
 */
exports.isAbsoluteDateFilterPreset = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "absolutePreset";
};
/**
 * Type-guard testing whether the provided object is an instance of {@link IRelativeDateFilterForm}.
 * @alpha
 */
exports.isRelativeDateFilterForm = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "relativeForm";
};
/**
 * Type-guard testing whether the provided object is an instance of {@link IRelativeDateFilterPreset}.
 * @alpha
 */
exports.isRelativeDateFilterPreset = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "relativePreset";
};
//# sourceMappingURL=types.js.map